<template>
  <div :style="styles" class="rt-advance-table-item">
    <div class="rt-advance-table-item-content">
      <el-checkbox v-bind="$attrs"> <slot /> </el-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtAdvanceTableItem',
  inject: ['col'],
  computed: {
    styles() {
      let pre = (1 / this.col) * 100;
      return {
        width: `calc(${pre}% )`
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtAdvanceTableItem.vue?4cab34e4